// Xforms standard features and adds them as .features to UIObject.
// expects cardsArr from an inventoryXform and a standardfeatures obj from an inventory response
define('lib/transforms/inventory.standardFeatures',[], function () {

  return function addStandardFeaturesToCard(cardsArr, standardfeatures) {

    cardsArr.forEach(function (item, idx) {
      var detailYear = item.year;
      var detailSeries = item.seriesName;
      // BAT 2980, reduced to single access operator.
      var yearFeatures = standardfeatures[detailYear];
      var features = yearFeatures[Object.keys(yearFeatures)[0]];

      var exteriorGroupArr = [];
      var interiorGroupArr = [];
      var safetyGroupArr = [];

      // if model.
      for (var i = 0; i < features.length; i++) {
        var group = features[i].group;
        if (group === 'Exterior') {
          exteriorGroupArr.push(features[i].title);

        } else if (group === 'Interior') {
          interiorGroupArr.push(features[i].title);

        } else if (group === 'Safety/Convenience') {
          safetyGroupArr.push(features[i].title);
        }
      }

      var exterior = {
        title: 'Exterior',
        content: exteriorGroupArr
      };

      var interior = {
        title: 'Interior',
        content: interiorGroupArr
      };


      var safety = {
        title: 'Safety/Convenience',
        content: safetyGroupArr
      };
      item.features = [exterior, interior, safety];
    });

    return cardsArr;
  };
});

